import { Heading, HeadingProps } from "@chakra-ui/react"
import classNames from "classnames"
import { forwardRef } from "react"

const BoldThemeHeader = forwardRef<HTMLHeadingElement, HeadingProps>(
  function BoldThemeHeader({ className, ...props }, ref) {
    return (
      <Heading
        ref={ref}
        as="h2"
        className={classNames("theme-heading theme-heading-bold", className)}
        color="white"
        fontWeight="700"
        textShadow="0 4px 4px rgba(0, 0, 0, 0.15)"
        // @ts-expect-error: TODO: get typing correct using chakra typegen https://chakra-ui.com/docs/get-started/cli#chakra-typegen
        size={{ base: "h4", md: "h2" }}
        lineHeight={{ base: "1.2", md: "1.4" }}
        {...props}
      />
    )
  }
)

export default BoldThemeHeader
